<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input class="input uppercase"
                type="text"
                placeholder="Name"
                v-model="innerValue.name"
                @keyup.enter="onFilterClick">
            </div>
          </div>
        </li>
        <li>
          <div class="field mt-4">
            <div class="control">
              <quote-template-tags :tags="tags"
                :tag-category-id="tagCategoryId"
                :selected-tags="selectedFilterTags"
                @toggle-tag="toggleTag" />
            </div>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteTemplateTags from './QuoteTemplateTags.vue'

export default {
  name: 'QuoteTemplateListSideMenu',
  components: {
    AppSideMenu,
    QuoteTemplateTags
  },
  props: {
    value: null,
    tags: {
      type: Array,
      default: () => []
    },
    tagCategoryId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      selectedFilterTags: []
    }
  },
  watch: {
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    onFilterClick() {
      if (this.selectedFilterTags.length > 0) {
        this.innerValue.tagIDs = this.selectedFilterTags
        this.$emit('input', this.innerValue)
      }
      this.$emit('filter')
    },
    onResetClick() {
      this.selectedFilterTags = []
      this.$emit('reset')
    },
    toggleTag(tag) {
      const idx = this.selectedFilterTags.indexOf(tag.tagID)
      if (idx === -1) {
        this.selectedFilterTags.push(tag.tagID)
      } else {
        this.selectedFilterTags.splice(idx, 1)
      }
    }
  }
}
</script>
